<template>
  <v-container>
    <v-progress-linear v-if="isLoading" indeterminate color="primary"></v-progress-linear>
    <div class="d-flex justify-center mt-4">
      <v-btn-toggle v-model="selectedView" class="mb-4" rounded tile mandatory>
        <v-btn variant="outlined" color="primary" value="admins">Admins</v-btn>
        <v-btn variant="outlined" color="primary" value="mitarbeiter">Mitarbeiter</v-btn>
        <v-btn variant="outlined" color="primary" value="group">Gruppen</v-btn>
      </v-btn-toggle>
    </div>
    
    <div v-if="selectedView === 'admins'">
      <v-autocomplete
          label="Mitarbeiter Suche"
          :items=nonAdminUsers
          @keydown.enter="onAdd"
          item-title="fullname"
          item-value="emplno"
          clearable
          v-model="selectedUser"
          no-data-text="Keine Mitarbeiter gefunden"
      ></v-autocomplete>
      <v-list>
        <v-list-item v-for="admin in adminUsers" :key="admin.emplno">
          <v-card color="secondary" >
            <v-card-title class="mb-0">{{ admin.fullname }}</v-card-title>
            <v-card-subtitle>{{ admin.email }}</v-card-subtitle>
           <v-card-actions>
             <v-btn v-if="this.$store.getters.emplno !== admin.emplno" icon color="error" class="mx-1" size="32" @click="onDelete(admin)">
               <v-icon>mdi-delete</v-icon>
             </v-btn>
           </v-card-actions>
          </v-card>
        </v-list-item>
      </v-list>
    </div>
    <div v-if="selectedView === 'mitarbeiter'">
      <v-autocomplete
          label="Mitarbeiter Suche"
          :items=usersWithFullname
          item-title="fullname"
          item-value="emplno"
          clearable
          v-model="selectedUser"
          no-data-text="Keine Mitarbeiter gefunden"
          @update:modelValue="onSelectedUserChange"
      ></v-autocomplete>

      <div v-if="selectedUserProfile != null">
        <div class="d-flex justify-center">
          <v-btn-toggle v-model="selectedViewUser" class="mb-4" rounded tile mandatory @update:modelValue="onViewUserChanged">
            <v-btn variant="outlined" color="primary" value="info">Info</v-btn>
            <v-btn variant="outlined" color="primary" value="wdp">WDP</v-btn>
            <v-btn variant="outlined" color="primary" value="up">UP</v-btn>
            <v-btn variant="outlined" color="primary" value="statistics">Statistik</v-btn>
            <v-btn variant="outlined" color="primary" value="email">Emails</v-btn>
            <v-btn variant="outlined" color="primary" value="view">View</v-btn>
          </v-btn-toggle>
        </div>
        <v-container v-if="selectedViewUser === 'info'">
          <v-row>
            <v-col cols="5" class="text-start">Name:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile.family_name }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="5" class="text-start ">Vorname:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile.name }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="5" class="text-start ">Mitarbeiter-Nr:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile?.EmployData?.emplno }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="5" class="text-start ">Schicht:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile?.EmployData?.cycleid }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="5" class="text-start">Email:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile.email }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="5" class="text-start">Urlaub:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile.EmployData?.vacations?.vacation1 }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="5" class="text-start">Resturlaub:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile.EmployData?.vacations?.vacation2 }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="5" class="text-start">Sonderurlaub:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile.EmployData?.vacations?.vacation3 }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="5" class="text-start">Letzter Login:</v-col>
            <v-col cols="7" class="text-start">{{ selectedUserProfile?.lastLogin ? selectedUserProfile.lastLogin.toLocaleString('de-DE') : 'Kein Login' }}</v-col>
          </v-row>

          <v-row>
          <v-col cols="6">
            <VCheckbox class="mb-2 v-checkbox--default" disabled label="Wunschdienstplan" v-model="hasWDP"></VCheckbox>
          </v-col>
          <v-col cols="6">
            <VCheckbox class="mb-2 v-checkbox--default" disabled label="Urlaubsplan" v-model="hasUP"></VCheckbox>
          </v-col>
        </v-row>
        <v-row v-if="isAdmin" class="mt-4">
          <v-col cols="12" class="text-start">
            <v-btn color="error" prepend-icon="mdi-delete" @click="onDeleteUser(selectedUserProfile)">Nutzer löschen</v-btn>
          </v-col>
        </v-row>
        </v-container>
        <div v-if="selectedViewUser === 'wdp'">
          <v-combobox
              v-model="selectedUserWishPeriod"
              :items="userWishesWithPeriods"
              item-title="period.title"
              label="Wunschdienstperiode"
              clearable
              hide-selected
              return-object></v-combobox>
          <div v-if="selectedUserWishPeriod">
            <WorkCalendar :wish-period="selectedUserWishPeriod.period"
                          :employ-wish-data="selectedUserWishPeriod">
            </WorkCalendar>

            <v-container class="mt-8 mb-4">
              <v-row class="d-flex flex-row align-content-center justify-space-around">
                <text-with-dot class="flex-1-0-0 text-center" label-text="Früh" color="orange"></text-with-dot>
                <text-with-dot class="flex-1-0-0 text-center" label-text="Mittel" color="pink"></text-with-dot>
                <text-with-dot class="flex-1-0-0 text-center" label-text="Spät" color="purple"></text-with-dot>
              </v-row>
              <v-row class="d-flex flex-row align-content-center">
                <text-with-dot class="flex-1-0-0 text-center" label-text="NE" color="blue"></text-with-dot>
                <text-with-dot class="flex-1-0-0 text-center" label-text="Geteilt" color="teal"></text-with-dot>
                <text-with-dot class="flex-1-0-0 text-center" label-text="Frei" color="green"></text-with-dot>
              </v-row>
            </v-container>
            <v-row class="mb-4">
              <v-col cols="5" class="text-left">
                <v-btn v-if="deleteWishes" color="error" @click="deleteUserWishes">Wünsche löschen</v-btn>
              </v-col>
              <v-col cols="7" class="text-start">
                <VCheckbox class="v-checkbox--default" label="Abgeschickt:" v-model="selectedUserWishPeriod.finished" disabled></VCheckbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="text-start">Bemerkung:</v-col>
              <v-col cols="7" class="text-start">
                {{ selectedUserWishPeriod?.bemerkung}}
              </v-col>
            </v-row>
          </div>
          <v-container v-else>
            <p v-if="userWishesWithPeriods.length > 0">Bitte wählen Sie eine Wunschdienstperiode aus</p>
            <p v-else>Keine Perioden für diesen Nutzer gefunden</p>
          </v-container>
        </div>
        <div v-if="selectedViewUser === 'up'">
          <v-combobox
              v-model="selectedUserVacation"
              :items="userVacations"
              item-title="year"
              label="Urlaubsperiode"
              clearable
              hide-selected
              return-object></v-combobox>
          
          <v-container v-if="selectedUserVacation">
            <v-row>
              <span><b>Infos</b></span>
            </v-row>
            <v-row>
              <v-col>
                <v-row>
                  <v-col cols="5" class="text-start">Jahr:</v-col>
                  <v-col cols="7" class="text-start">{{ selectedUserVacation.year }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Abgeschickt:</v-col>
                  <VCheckbox class="v-checkbox--default text-center pa-4" v-model="selectedUserVacation.finished" disabled></VCheckbox>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="selectedUserVacation.priorityOne">
              <v-col>
                <h4>{{ `1. Prio` }}</h4>
                <v-row>
                  <v-col cols="5" class="text-start">Urlaubstage (geschätzt):</v-col>
                  <v-col cols="7" class="text-start">{{ calculateVacationDays(selectedUserVacation.priorityOne?.startDate, selectedUserVacation.priorityOne?.endDate) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Prio Zeitraum:</v-col>
                  <v-col cols="7" class="text-start">{{ toShortDateString(selectedUserVacation.priorityOne.startDate)}} - {{toShortDateString(selectedUserVacation.priorityOne.endDate) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Bemerkung:</v-col>
                  <v-col cols="7" class="text-start">{{ selectedUserVacation.priorityOne.bemerkung }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="selectedUserVacation.priorityTwo">
              <v-col>
                <h4>{{ `2. Prio` }}</h4>
                <v-row>
                  <v-col cols="5" class="text-start">Urlaubstage (geschätzt):</v-col>
                  <v-col cols="7" class="text-start">{{ calculateVacationDays(selectedUserVacation.priorityTwo?.startDate, selectedUserVacation.priorityTwo?.endDate) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Prio Zeitraum:</v-col>
                  <v-col cols="7" class="text-start">{{ toShortDateString(selectedUserVacation.priorityTwo?.startDate ?? null)}} - {{toShortDateString(selectedUserVacation?.priorityTwo.endDate ?? null) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Bemerkung:</v-col>
                  <v-col cols="7" class="text-start">{{ selectedUserVacation.priorityTwo.bemerkung }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="selectedUserVacation.priorityThree">
              <v-col>
                <h4>{{ `3. Prio` }}</h4>
                <v-row>
                  <v-col cols="5" class="text-start">Urlaubstage (geschätzt):</v-col>
                  <v-col cols="7" class="text-start">{{ calculateVacationDays(selectedUserVacation.priorityThree?.startDate, selectedUserVacation.priorityThree?.endDate) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Prio Zeitraum:</v-col>
                  <v-col cols="7" class="text-start">{{ toShortDateString(selectedUserVacation.priorityThree?.startDate ?? null)}} - {{toShortDateString(selectedUserVacation.priorityThree?.endDate ?? null) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Bemerkung:</v-col>
                  <v-col cols="7" class="text-start">{{ selectedUserVacation.priorityThree.bemerkung }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="selectedUserVacation.priorityFour">
              <v-col>
                <h4>{{ `4. Prio` }}</h4>
                <v-row>
                  <v-col cols="5" class="text-start">Urlaubstage (geschätzt):</v-col>
                  <v-col cols="7" class="text-start">{{ calculateVacationDays(selectedUserVacation.priorityFour?.startDate, selectedUserVacation.priorityFour?.endDate) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Prio Zeitraum:</v-col>
                  <v-col cols="7" class="text-start">{{ toShortDateString(selectedUserVacation?.priorityFour?.startDate ?? null) }} - {{ toShortDateString(selectedUserVacation?.priorityFour?.endDate ?? null) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-start">Bemerkung:</v-col>
                  <v-col cols="7" class="text-start">{{ selectedUserVacation.priorityFour.bemerkung }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="selectedUserVacation.reliefDays.length > 0">
              <v-col>
                <h4>{{ `Entlastungstage` }}</h4>
                <v-list>
                  <v-list-item v-for="(reliefDay, index) in selectedUserVacation.reliefDays" :key="index">
                    <v-row>
                      <v-col cols="5" class="text-start">Datum:</v-col>
                      <v-col cols="7" class="text-start">{{ reliefDay }}</v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-else>
            <p v-if="userVacations.length > 0">Bitte wählen Sie eine Urlaubsperiode aus</p>
            <p v-else>Keine Perioden für diesen Nutzer gefunden</p>
          </v-container>
        </div>
        <div v-if="selectedViewUser == 'statistics'">
          <v-container v-if="!selectedUserVacationishPeriod">
            <v-combobox
              v-model="selectedUserWishPeriodPDF"
              :items="wishPeriodsPDF"
              item-title="title"
              item-text="title"
              label="Wunschdienstperiode"
              clearable
              hide-selected
              return-object></v-combobox>

            <v-container v-if="selectedUserWishPeriodPDF">
              <WorkStatisticUser :wish-period="selectedUserWishPeriodPDF"
                            :user-data="selectedUserProfile">
              </WorkStatisticUser>
<!--            <WorkStatistic :wish-period="selectedUserWishPeriod.period"
                          :employ-wish-data="selectedUserWishPeriod">
            </WorkStatistic>-->
            </v-container>
            <v-container v-else>
              <p v-if="userWishesWithPeriods.length > 0">Bitte wählen Sie eine Wunschdienstperiode aus</p>
              <p v-else>Keine Perioden für diesen Nutzer gefunden</p>
            </v-container>
          </v-container>
          <v-container v-if="!selectedUserWishPeriodPDF">
            <v-combobox
                v-model="selectedUserVacationishPeriod"
                :items="vacationwishPeriods"
                item-title="year"
                item-text="year"
                label="Urlaubswunschperiode"
                clearable
                hide-selected
                return-object></v-combobox>
            <div v-if="selectedUserVacationishPeriod">
              <P>Urrlaubswunsch Statistik!.</P>
            </div>
            <v-container v-else>
              <p v-if="userVacationsWithPeriods.length > 0">Bitte wählen Sie eine Urlaubswunschperiode aus</p>
              <p v-else>Keine Perioden für diesen Nutzer gefunden</p>
            </v-container>
          </v-container>
        </div>
        <div class="pa-0 w-100" v-if="selectedViewUser === 'email'">
          <EmailList :email-adress="selectedUserProfile?.EmployData?.email"></EmailList>
        </div>
        <div v-if="selectedViewUser == 'view'">
          <div v-if="!selectedUserVacationishPeriod">
            <v-combobox
                v-model="selectedUserWishPeriodPDF"
                :items="wishPeriodsPDF"
                item-title="title"
                item-text="title"
                label="Wunschdienstperiode"
                clearable
                hide-selected
                return-object></v-combobox>
            <WorkView v-if="selectedUserWishPeriodPDF" 
                  :wish-period="selectedUserWishPeriodPDF"
                  :user-data="selectedUserProfile">
            </WorkView>
            <v-container v-else>
              <p v-if="userWishesWithPeriods.length > 0">Bitte wählen Sie eine Wunschdienstperiode aus</p>
              <p v-else>Keine Perioden für diesen Nutzer gefunden</p>
            </v-container>
          </div>
          <div v-if="!selectedUserWishPeriodPDF">
            <v-combobox
              v-model="selectedUserVacationishPeriod"
              :items="vacationwishPeriods"
              item-title="year"
              item-text="year"
              label="Urlaubswunschperiode"
              clearable
              hide-selected
              return-object>
            </v-combobox>
            <VacationView v-if="selectedUserVacationishPeriod" 
                    :vacation-period="selectedUserVacationishPeriod"
                    :user-data="selectedUserProfile">
            </VacationView>
            <v-container v-else>
              <p v-if="userVacationsWithPeriods.length > 0">Bitte wählen Sie eine Urlaubswunschperiode aus</p>
              <p v-else>Keine Perioden für diesen Nutzer gefunden</p>
            </v-container>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedView === 'group'">
      <v-autocomplete
          label="Gruppe Suche"
          :items=groups
          item-title="text"
          item-value="member"
          clearable
          v-model="selectedGroup"
          no-data-text="Keine Gruppe gefunden"
          return-object
      ></v-autocomplete>

      <div v-if="selectedGroup">
        <v-autocomplete
          label="Schicht Suche"
          :items=employCycles
          @keydown.enter="onSchichtAdd"
          :item-title="(item) => `${item.cycleid} ${item.machineid} (${item.jobids.join(', ')})`"
          item-value="cycleid"
          clearable
          v-model="selectedSchicht"
          no-data-text="Keine Schicht gefunden"
          return-object
        ></v-autocomplete>
        <v-list>
          <v-list-item v-for="(schicht, index) in selectedGroup.member" :key="index">
            <v-card color="secondary" >
              <v-card-title class="mb-0">{{ schicht.name }} {{ schicht.cycleid }}
                <v-btn icon color="error" class="mx-1" size="32" @click="onSchichtDelete(schicht, index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-list-item>
        </v-list>
      </div>
    </div>
  </v-container>
</template>

<script lang="ts">
import {computed, ref, watch} from 'vue';
import { useCollection, useFirestore } from 'vuefire'
import { collection, updateDoc, doc, getDocs, writeBatch, deleteDoc } from 'firebase/firestore'
import { GetUserDataEmplno } from '@/data/userData'
import { SetGroupDatatoEmploy } from '@/data/groupData'
import { createDialog } from 'vuetify3-dialog'
import { notifySuccess } from 'vuetify3-dialog'
import {GetWishesData} from "@/data/wishData";
import {useRouter} from "vue-router";
import {useStore} from "@/store";
import WorkCalendar from "@/components/WorkCalendar.vue";
import TextWithDot from "@/components/TextWithDot.vue";
import EmailList from "@/components/EmailList.vue";
import {GetUserVacationsData} from "@/data/vacationData";
import {GetWishPeriodsData} from "@/data/wishPeriod"
import {GetVacationPeriodsData} from "@/data/vacationPeriod"
//import WorkStatistic from "@/components/WorkStatistic.vue"
import WorkStatisticUser from "@/components/WorkStatisticUser.vue"
import WorkView from "@/components/WorkView.vue";
import VacationView from "@/components/VacationView.vue"
import { hasUncaughtExceptionCaptureCallback } from 'process';
import { create } from 'domain';
export default {
  name: 'UserManagementView',
  components: { VacationView, WorkView, WorkStatisticUser, EmailList, TextWithDot, WorkCalendar, VCheckbox: () => import('@new-mg/vuetify-new-theme'),},
  setup() {
    const selectedView = ref('admins');
    const selectedViewUser = ref('info');
    const db = useFirestore();
    const router = useRouter();
    const store = useStore();
    const isAdmin = computed(() => store.getters.isAdmin);
    const users = useCollection(collection(db, 'userData'));
    const wishPeriods = useCollection(collection(db, 'wishPeriods'));
    const groups = useCollection(collection(db, 'groupData'))
    const employ = useCollection(collection(db, 'employ'));
    const isLoading = ref(false);
    const hasWDP = ref(false)
    const hasUP = ref(false)
    const usersWithFullname = computed(() => {
      return users.value.map(user => {
        return {
          ...user,
          fullname: user.name + ' ' + user.family_name
        }
      });
    });
    
    const inputText = ref('')
    const deleteWishes = ref(false)
    const selectedUserWishPeriod = ref(null)
    const selectedUserWishPeriodPDF = ref(null)
    const selectedUserVacationishPeriod = ref(null)
    const selectedUser = ref(null)
    const selectedGroup = ref(null)
    const selectedSchicht = ref(null)
    const selectedUserProfile = ref<UserData| null>(null);
    const userWishes = ref<WishData[]>([]);
    const userVacations = ref<VacationData[]>([]);
    const selectedUserVacation = ref(null);
    const wishPeriodsPDF = ref([])
    const vacationwishPeriods = ref([])
    const userWishesWithPeriods = computed(() => {
      return userWishes.value.map(userWish => {
        return {
          ...userWish,
          period: wishPeriods.value.find(period => period.id === userWish.wishPeriodId) as WishPeriod
        }
      });
    });
    const userVacationsWithPeriods = computed(() => {
      return userVacations.value.map(userVacation => {
        return {
          ...userVacation,
          period: vacationwishPeriods.value.find(period => period.year === userVacation.year) as VacationPeriod
        }
      });
    });

    const employCycles = computed(() => {
      const cycleMap = new Map()
      employ.value.forEach(({ cycleid, machineid, jobid }) => {
        if (!cycleMap.has(cycleid)) {
          cycleMap.set(cycleid, { cycleid, machineid, jobids: new Set() })
        }
        cycleMap.get(cycleid).jobids.add(jobid) // Set verhindert doppelte jobids
      });

      // Konvertiere Sets zurück in Arrays, weil Vue keine Sets in Templates rendert
      const allCycles = Array.from(cycleMap.values()).map(entry => ({
        ...entry,
        jobids: Array.from(entry.jobids)
      }))
      // Filtere die Elemente basierend auf filterCycles
      const filterArr = selectedGroup?.value?.member ? selectedGroup.value.member : []
      return allCycles.filter(cycle => !filterArr.some(filter => filter.cycleid === cycle.cycleid))
    })

    function calculateVacationDays(startDate: Date, endDate: Date): number {

      if(startDate === null || endDate === null) return 0;

      const start = new Date(startDate);
      const end = new Date(endDate);

      // Calculate the total number of days (inclusive of start and end date)
      const totalDays = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;

      // Calculate full 7-day weeks and remaining days
      const fullWeeks = Math.floor(totalDays / 7);
      const remainingDays = totalDays % 7;

      // Calculate vacation days
      const vacationDays = (fullWeeks * 5) + remainingDays;

      return vacationDays;
    }

    function toShortDateString(date: Date | null | number): string {
      if (!date) return ""
      if (date === null) return ""
      const validDate = typeof date === 'number' ? new Date(date) : date
      return validDate.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit'
      })
    }

    function onSelectedUserChange(newValue) {
      // Hier kannst du auf die Änderung reagieren
      console.log('Neuer Wert:', newValue);
      selectedUserWishPeriod.value = null
      selectedUserVacation.value = null
      selectedUserWishPeriodPDF.value = null
      selectedUserVacationishPeriod.value = null
      
    }

    function onViewUserChanged(newValue) {
      // Hier kannst du auf die Änderung reagieren
      console.log('Neuer Wert:', newValue);
      selectedUserWishPeriod.value = null
      selectedUserVacation.value = null
      selectedUserWishPeriodPDF.value = null
      selectedUserVacationishPeriod.value = null
    }
    watch(selectedUser, async (newUser) => {
      userWishes.value = [];
      wishPeriodsPDF.value = [];
      vacationwishPeriods.value = [];
      userVacations.value = [];
      if (newUser) {
        try {
          isLoading.value = true;
          selectedUserProfile.value = await GetUserDataEmplno(selectedUser.value)
          hasWDP.value = selectedUserProfile.value?.EmployData?.isWDP ? selectedUserProfile.value.EmployData.isWDP : false
          hasUP.value = selectedUserProfile.value?.EmployData?.isUP ? selectedUserProfile.value.EmployData.isUP : false
          console.log("Employee Get UserData",selectedUserProfile, newUser, selectedUser.value)
          try {
            userWishes.value = await GetWishesData(selectedUserProfile.value.emplno);
            //userWishes.value = await GetWishesData(selectedUser.value);
          } catch (e) {
            console.log('Error getting user wishes: ', e);
          }
          try {
            userVacations.value = await GetUserVacationsData(selectedUserProfile.value.emplno);
            //userVacations.value = await GetUserVacationsData(selectedUser.value);
          } catch (e) {
            console.log('Error getting user vacations: ', e);
          }
        }
        catch (e) {
          console.error('Error getting user data: ', e);
        } finally {
          selectedUserWishPeriod.value = null
          selectedUserWishPeriodPDF.value = null
          selectedUserVacationishPeriod.value = null
          selectedViewUser.value = "info"
          try {
            wishPeriodsPDF.value = await GetWishPeriodsData();
          } catch (e) {
            console.error('Error getting wish periods: ', e);
          }
          try {
            vacationwishPeriods.value = await GetVacationPeriodsData();
          } catch (e) {
            console.error('Error getting vacation periods: ', e);
          }
          isLoading.value = false
        }
      }
    });
    
    watch(selectedView, () => {
        inputText.value = '';
        selectedUser.value = null;
        selectedUserProfile.value = null;
    });

    watch(selectedUserWishPeriod, (newPeriod) => {
      if (newPeriod) {
        if(selectedUserWishPeriod.value && selectedUserWishPeriod.value.period.locked == false) {
          deleteWishes.value = true
        } else {
          deleteWishes.value = false
        }
      }
    })

    watch(selectedGroup, (newGroup) => {
      if (newGroup) {
        console.log("NewGroup", newGroup)
      }
    })

    const isAddButtonDisabled = computed(() => selectedUser.value === null);
    const onAdd =() =>{
      createDialog({ title: "Admin hinzufügen",
        text: `Möchten Sie den ausgewählen Admin hinzufügen?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then((answer) => {
            if(answer)
            {
              try {
                const itemDoc = doc(db, 'userData', selectedUser.value.sub);
                updateDoc(itemDoc, {
                  isAdmin: true,
                });
              } catch (e) {
                console.error('Error updating document: ', e);
              }
              finally {
                notifySuccess("Admin erfolgreich hinzugefügt!").then(() => {});
                selectedUser.value = null;
              }
            }
          })
    }
    const onDelete = async (admin) => {
      createDialog({ title: "Admin löschen", 
        text: `Möchten Sie den Admin ${admin.name} ${admin.family_name} löschen?`, 
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then((answer) => {
            if(answer)
            {
              try {
                const itemDoc = doc(db, 'userData', admin.sub);
                updateDoc(itemDoc, {
                  isAdmin: false,
                });
              } catch (e) {
                console.error('Error deleting document: ', e);
              }
              finally {
                notifySuccess("Admin erfolgreich gelöscht!").then(() => {});
              }
            }
          })
    }

    const onSchichtAdd = async () => {
      const schicht = selectedSchicht.value
      createDialog({ title: "Admin löschen", 
        text: `Möchten Sie die Schicht ${schicht.machineid} ${schicht.cycleid} einfügen?`, 
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then((answer) => {
            if(answer)
            {
              const group = selectedGroup.value
              try {
                const itemDoc = doc(db, 'groupData', group.id)
                let name = schicht.machineid
                let jobids = ""
                for (const jobid of schicht.jobids) {
                  jobids += ` ${jobid}` 
                }
                if (jobids != "") {
                  name = `${name} (${jobids} )`
                }
                group.member.push({cycleid: schicht.cycleid, name: name})
                updateDoc(itemDoc, {
                  member: group.member,
                });
              } catch (e) {
                console.error('Error deleting document: ', e)
              }
              finally {
                notifySuccess("Schicht erfolgreich eingefügt!").then(() => {})
                selectedSchicht.value = null
                SetGroupDatatoEmploy(schicht.cycleid, { [group.right]: true })
              }
            }
          })
    }

    const onSchichtDelete = async (schicht, index) => {
      createDialog({ title: "Admin löschen", 
        text: `Möchten Sie die Schicht ${schicht.name} ${schicht.cycleid} löschen?`, 
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then((answer) => {
            if(answer)
            {
              const group = selectedGroup.value
              try {
                const itemDoc = doc(db, 'groupData', group.id)
                console.log("DOC: ", index, itemDoc)
                group.member.splice(index, 1)
                updateDoc(itemDoc, {
                  member: group.member,
                });
              } catch (e) {
                console.error('Error deleting document: ', e)
              }
              finally {
                notifySuccess("Schicht erfolgreich entfernt!").then(() => {})
                SetGroupDatatoEmploy(schicht.cycleid, { [group.right]: false })
              }
            }
          })
    }
    
    const deleteUserWishes = async () => {
      console.log("Delete Wishes for ", selectedUserWishPeriod.value)
      createDialog({ title: "Wünsche löschen", 
        text: `Möchten Sie die Wünsche für die Periode ${selectedUserWishPeriod.value.title} löschen?`, 
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then(async (answer) => {
            if(answer)
            {
              debugger;
              try {
                const docRef = doc(db, 'wishData', selectedUserWishPeriod.value.id);
                // 1. Alle Subcollections löschen
                const subcollectionRef = collection(docRef, "dates");
                const subcollectionSnapshot = await getDocs(subcollectionRef); 
                // Batch für bessere Performance
                const batch = writeBatch(db);
                subcollectionSnapshot.docs.forEach((subDoc) => {
                  batch.delete(subDoc.ref);
                });
                
                if (subcollectionSnapshot.docs.length > 0) {
                  await batch.commit();
                }
                // 2. Hauptdokument löschen
                await deleteDoc(docRef);
                selectedUserWishPeriod.value = null
                try {
                  userWishes.value = await GetWishesData(selectedUserProfile.value.emplno);
                } catch (e) {
                  console.log('Error getting user wishes: ', e);
                }
              } catch (e) {
                console.error('Error updating document: ', e);
              }
              finally {
                notifySuccess("Wünsche erfolgreich gelöscht!").then(() => {});
              }
            }
          })
    }

    const onDeleteUser = async (user) => {
      if (!isAdmin.value) {
        console.warn('Keine Berechtigung zum Löschen von Nutzern.');
        return;
      }
      createDialog({ title: "Nutzer löschen",
        text: `Möchten Sie den Nutzer ${user.name} ${user.family_name} wirklich unwiderruflich löschen?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then(async (answer) => {
            if(answer)
            {
              try {
                await deleteDoc(doc(db, 'userData', user.sub));
                selectedUser.value = null;
                selectedUserProfile.value = null;
                notifySuccess("Nutzer erfolgreich gelöscht!").then(() => {});
              } catch (e) {
                console.error('Error deleting user: ', e);
              }
            }
          })
    }

    const adminUsers = computed(() => {
      return usersWithFullname.value.filter(user => user.isAdmin);
    });

    const nonAdminUsers = computed(() => {
      return usersWithFullname.value.filter(user => !user.isAdmin);
    });
    
    function goToWDPInfo(selectedPeriod)
    {
      router.push({name: 'wunschdienstInfo', params: {wunschdienstId: selectedPeriod.period.id, userId: selectedUser.value}});
    }
    return {
      isAddButtonDisabled,
      selectedView, 
      userWishesWithPeriods,
      isLoading, 
      calculateVacationDays, 
      toShortDateString, 
      inputText, 
      userWishes, 
      userVacations, 
      selectedUserWishPeriod,
      selectedUserWishPeriodPDF,
      goToWDPInfo,
      selectedUserVacation, 
      usersWithFullname, 
      adminUsers,
      nonAdminUsers, 
      selectedUser,
      selectedUserProfile, 
      isAdmin,
      onDeleteUser,
      onDelete, 
      onAdd, 
      selectedViewUser,
      wishPeriodsPDF,
      selectedUserVacationishPeriod,
      vacationwishPeriods,
      userVacationsWithPeriods,
      groups,
      selectedGroup,
      selectedSchicht,
      onSchichtDelete,
      onSchichtAdd,
      employCycles,
      hasWDP,
      hasUP,
      onViewUserChanged,
      onSelectedUserChange,
      deleteWishes,
      deleteUserWishes,
    };
  },
};
</script>

<style scoped>
.responsive {
  padding: var(--new-responsive-space);
}

.wrap-text {
  word-wrap: break-word;
}

.main-container {
  width: 100%;
  display: flex;
  justify-content: space-between; /* Ensures items are on opposite ends */
  align-items: center; /* Vertically centers the items */
  padding: 10px;
  border: 1px solid #ccc; /* Optional, for visualization */
}

.gradient {
  color: var(--new-primary-weiß);
  background-image: linear-gradient(90deg,
  rgba(0, 75, 160, 1) 0%,
  rgba(37, 31, 117, 1) 100%);
}

.round-corners {
  border-radius: 5px;
}

.shadow {
  box-shadow: 0 0 20px rgba(34, 38, 47, 0.1);
}

</style>
